import { htmlDecodeMaster } from '../../../common/functions';

function HtmlRenderer(props) {
  return props.content
    ? htmlDecodeMaster(props.content, props.length, props.escapeHtml)
    : '';
}

export default HtmlRenderer;
